"use client";

/**
 * Shared instrument widget frame — bezel + body.
 * Use for all desk operational widgets so chrome stays consistent.
 */
import React from "react";
import type { WidgetChromeProps } from "./lib/types";
import styles from "./WidgetChrome.module.css";

export function WidgetChrome({
  label,
  meta,
  bezelExtra,
  "aria-label": ariaLabel,
  className = "",
  children,
  emphasis = "default",
}: WidgetChromeProps) {
  return (
    <section
      className={[
        styles.widget,
        emphasis === "primary" ? styles.widgetPrimary : "",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
      aria-label={ariaLabel ?? label}
    >
      <div className={styles.bezel}>
        <span className={styles.mark} aria-hidden />
        <span className={styles.label}>{label}</span>
        {meta ? <span className={styles.meta}>{meta}</span> : null}
        {bezelExtra != null ? (
          <div className={styles.bezelExtra}>{bezelExtra}</div>
        ) : null}
      </div>
      <div
        className={[
          styles.body,
          emphasis === "primary" ? styles.bodyPrimary : "",
        ]
          .filter(Boolean)
          .join(" ")}
      >
        {children}
      </div>
    </section>
  );
}

export { styles as widgetChromeStyles };
